import React from 'react';

import { SubHeading } from '../../components'
import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Where Style Evolution Begins" />
      <h1 className="app__header-h1">Cari Gaya Rambut Terbaikmu</h1>
      <p className="p__opensans" style={{margin: '2rem 0'}}>Pilihan Anda untuk gaya rambut yang sempurna. Di ClipperCraft, kami memahami bahwa gaya rambut adalah ungkapan diri yang unik bagi setiap individu. </p>
      <button type="button" className="custom__button">Explore Menu</button>
    </div>
    <div className="app__wrapper_img">
      <img src={images.chair} alt="chair img" />
    </div>
  </div>
);

export default Header;
